import React, { useState, useEffect } from 'react';
import api, { getApiErrorMessage } from '../api';
import './Téléchargement.css';

const Téléchargement = ({ type, showViewer = false }) => {
  const [pdfs, setPdfs] = useState([]);
  const [newPdf, setNewPdf] = useState({ title: '', file: null, type });
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // État de la connexion de l'utilisateur
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Vérifiez si l'utilisateur est connecté, par exemple avec un token dans le localStorage
    const token = localStorage.getItem('token'); // Exemple d'utilisation du localStorage
    if (token) {
      setIsLoggedIn(true); // Si le token existe, on considère que l'utilisateur est connecté
    }

    fetchPdfs(type);
  }, [type]);

  const fetchPdfs = async (type) => {
    try {
      const response = await api.get(`/api/pdfs/${type}`);
      setPdfs(response.data);
    } catch (error) {
      console.error('Erreur lors de la récupération des PDFs:', error);
    }
  };

  const handleAddPdf = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append('title', newPdf.title);
    formData.append('pdf', newPdf.file);
    formData.append('type', newPdf.type);

    try {
      const response = await api.post('/api/pdfs', formData);
      setPdfs([...pdfs, response.data]);
      setNewPdf({ title: '', file: null, type });
    } catch (error) {
      const message = getApiErrorMessage(error);
      setErrorMessage(message);
      console.error('Erreur lors de l\'ajout du PDF:', error);
    }
  };

  const handleDeletePdf = async (id) => {
    try {
      await api.delete(`/api/pdfs/${id}`);
      setPdfs(pdfs.filter(pdf => pdf._id !== id));
    } catch (error) {
      const message = getApiErrorMessage(error);
      setErrorMessage(message);
      console.error('Erreur lors de la suppression du PDF:', error);
    }
  };

  const getDownloadLink = (pdfUrl) => {
    return `${pdfUrl.replace('/upload/', '/upload/fl_attachment/')}`;
  };

  return (
    <div className="pdf-container">
      {isLoggedIn && (
        <form className="form-container" onSubmit={handleAddPdf}>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
          <input
            type="text"
            className="form-input-text"
            placeholder="Titre du PDF"
            value={newPdf.title}
            onChange={(e) => setNewPdf({ ...newPdf, title: e.target.value })}
          />
          <input
            type="file"
            className="form-input-file"
            accept=".pdf"
            onChange={(e) => setNewPdf({ ...newPdf, file: e.target.files[0] })}
          />
          <button className="form-button" type="submit">Ajouter</button>
        </form>
      )}

      {showViewer && selectedPdf && (
        <div className="pdf-viewer-container">
          <div className="pdf-viewer-header">
            <h3>{selectedPdf.title}</h3>
            <button className="pdf-button-close" onClick={() => setSelectedPdf(null)}>
              Fermer
            </button>
          </div>
          <iframe
            src={selectedPdf.pdfUrl}
            title={selectedPdf.title}
            className="pdf-viewer"
          />
        </div>
      )}

      <ul className="pdf-list">
        {pdfs.map(pdf => (
          <li key={pdf._id} className="pdf-item">
            <p>{pdf.title}</p>
            {showViewer && (
              <button className="pdf-button-view" onClick={() => setSelectedPdf(pdf)}>
                Voir
              </button>
            )}
            <button className="pdf-button-download" onClick={() => window.open(getDownloadLink(pdf.pdfUrl), '_blank')}>
              Télécharger
            </button>
            {isLoggedIn && (
              <button className="pdf-button-delete" onClick={() => handleDeletePdf(pdf._id)}>Supprimer</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Téléchargement;
